import { type ComponentProps } from 'react';
import cn from 'clsx';
import { cva, type VariantProps } from 'class-variance-authority';

import styles from './Visibility.module.css';

const visibilityVariants = cva(styles.visibility, {
  variants: {
    visibleFrom: {
      tabletPortrait: styles.visibleFromTabletPortrait,
      tabletLandscape: styles.visibleFromTabletLandscape,
      laptop: styles.visibleFromLaptop,
      desktop: styles.visibleFromDesktop,
    },
    visibleTo: {
      tabletPortrait: styles.visibleToTabletPortrait,
      tabletLandscape: styles.visibleToTabletLandscape,
      laptop: styles.visibleToLaptop,
      desktop: styles.visibleToDesktop,
    },
  },
});

type VisibilityVariants = VariantProps<typeof visibilityVariants>;

type VisibilityProps =
  | ({ visibleFrom: NonNullable<VisibilityVariants['visibleFrom']>; visibleTo?: never } & ComponentProps<'div'>)
  | ({ visibleFrom?: never; visibleTo: NonNullable<VisibilityVariants['visibleTo']> } & ComponentProps<'div'>);

export const Visibility = ({ visibleFrom, visibleTo, className, ...props }: VisibilityProps) => (
  <div className={cn(visibilityVariants({ visibleFrom, visibleTo }), className)} {...props} />
);
